import React, { useRef } from 'react';

import '../ui/css/LoginPage.css';
import { LoginUserData } from '../types/interfaces';

const TestPage = () => {
  const values = useRef<LoginUserData | null>({
    username: '',
    password: ''
  });

  const handleChange =
    (name: string) => (event: { target: { value: string } }) => {
      values.current = { ...values.current, [name]: event.target.value };
    };

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
  };

  return (
    <div className="wrapper">
      <div className="logo-header">
        <img src={require('../Logo.png')} alt="rtk-logo" />
      </div>
      <form className="autorization-form" onSubmit={handleSubmit}>
        <div className="autorization-form__message">Требуется вход</div>
        <hr className="autorization-form__hr" />
        <input
          className="autorization-form__input"
          id="username"
          placeholder="Имя пользователя"
          onChange={handleChange('username')}
          required
        />
        <input
          className="autorization-form__input"
          id="password"
          placeholder="Пароль"
          onChange={handleChange('password')}
          type="password"
          required
        />
        <button
          className="autorization-form__submit"
          type="submit"
          color="primary"
        >
          Вход
        </button>
      </form>
    </div>
  );
};
export default TestPage;
